import React from 'react';

import PropTypes from 'prop-types';

const CrumbSeparator = ({ children }) => <div className="cr-topbar__separator">{children}</div>;

CrumbSeparator.propTypes = {
  children: PropTypes.node.isRequired,
};

export default CrumbSeparator;
